import DetailCompany from "./DetailCompany";

export default DetailCompany;
